import { OrderStrategiesEnum } from '@src/tokens/orderStrategy';
import type { AlgoConfigurationParameterEnum, IOrderConfigurationSnapshot, Order } from '@talos/kyoko';
import Big from 'big.js';

const SUPPORTED_STRATEGIES = [
  OrderStrategiesEnum.MarketTWAP,
  OrderStrategiesEnum.TWAP,
  OrderStrategiesEnum.Quantizer,
  OrderStrategiesEnum.MarketQuantizer,
  OrderStrategiesEnum.MultilegTWAP,
];

const CLIP_STRATEGIES = [OrderStrategiesEnum.Quantizer, OrderStrategiesEnum.MarketQuantizer];

// TODO: this is very much temporary, will be driven by backend
export const canBackendCalculateTrajectory = (order: Pick<Order, 'Strategy'>): boolean =>
  !!order.Strategy?.includes('VWAP');

export const shouldDisplayTrajectory = (order: Order): boolean =>
  canBackendCalculateTrajectory(order) ||
  (!!order.Strategy && SUPPORTED_STRATEGIES.includes(order.Strategy as OrderStrategiesEnum));

export const isClipBased = (order: Order): boolean =>
  !!order.Strategy && CLIP_STRATEGIES.includes(order.Strategy as OrderStrategiesEnum);

export function doesSnapshotConfigHave(
  snapshot: IOrderConfigurationSnapshot,
  ...paramKeys: Array<AlgoConfigurationParameterEnum>
): boolean {
  for (const key of paramKeys) {
    const config = snapshot.OrderConfig.find(config => config.Param === key);
    if (!config || !config.Value) {
      return false;
    }
  }
  return true;
}

export function getSnapshotConfigValue(
  snapshot: IOrderConfigurationSnapshot,
  paramKey: AlgoConfigurationParameterEnum
): Big {
  const config = snapshot.OrderConfig.find(config => config.Param === paramKey);
  if (!config || !config.Value) {
    throw new Error(`Parameter ${paramKey} not found in Order Snapshot Config`);
  }

  return new Big(config.Value);
}
